/*
 * Carritos guardados con nombre (snippets/cv-saved-carts.liquid).
 *
 * - Botón "Guardar carrito" ([data-cv-save-cart], en el carrito lateral y en
 *   /cart): pide un nombre y guarda una copia del carrito en la cuenta. Una
 *   casilla permite vaciarlo después para empezar otro pedido. Sin sesión,
 *   invita a iniciarla.
 * - Página Mi cuenta → Carritos ([data-cvsc-list], customers/account.carritos):
 *   lista, carga al carrito (reemplazando o agregando), renombra y elimina.
 *
 * Al cargar un carrito, cada línea lleva la propiedad oculta _carrito_guardado
 * con su id. Cuando un pedido trae esa marca, la página manda el id en
 * `pedidos` y el servicio lo saca de la lista.
 */
(function() {
  'use strict';

  var MARK = '_carrito_guardado';

  // Para guardar se quitan las marcas que el tema vuelve a poner solo
  // (ubicación y tipo de entrega, cart-pin-stamp.js) y la de un carrito anterior.
  function keepProp(name) {
    return name.indexOf('_cv_') !== 0 && name !== MARK;
  }

  function cleanProps(props) {
    if (!props || typeof props !== 'object') return null;
    var out = null;
    Object.keys(props).sort().forEach(function(name) {
      var value = props[name];
      if (!keepProp(name) || value === null || value === undefined || value === '') return;
      out = out || {};
      out[name] = String(value);
    });
    return out;
  }

  function clip(value, max) {
    if (value === null || value === undefined) return undefined;
    var text = String(value).replace(/\s+/g, ' ').trim();
    return text ? text.slice(0, max) : undefined;
  }

  // Líneas de /cart.js -> lo que guarda el servicio (con lo necesario para mostrarlas).
  function itemsFromCart(cart) {
    return ((cart && cart.items) || []).map(function(item) {
      var line = {
        id: item.variant_id,
        q: item.quantity,
        t: clip(item.product_title || item.title, 200) || 'Producto',
        v: item.variant_title && item.variant_title !== 'Default Title' ? clip(item.variant_title, 200) : undefined,
        s: clip(item.sku, 100),
        h: item.handle || undefined,
        img: typeof item.image === 'string' ? item.image : undefined,
        pr: typeof item.final_price === 'number' ? item.final_price : undefined
      };
      var p = cleanProps(item.properties);
      if (p) line.p = p;
      return line;
    });
  }

  // Líneas de un carrito guardado -> /cart/add.js, marcadas con su id.
  function addsFromSaved(saved) {
    return (saved.items || []).map(function(line) {
      var properties = {};
      Object.keys(line.p || {}).forEach(function(name) { if (keepProp(name)) properties[name] = line.p[name]; });
      properties[MARK] = saved.id;
      return { id: line.id, quantity: line.q, properties: properties };
    });
  }

  window.CVSavedCarts = { itemsFromCart: itemsFromCart, addsFromSaved: addsFromSaved, cleanProps: cleanProps };

  /* ------------------------------------------------------------------ */

  var node = typeof document !== 'undefined' && document.getElementById
    ? document.getElementById('cv-saved-carts-config')
    : null;
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (e) { return; }
  if (!config || !config.url) return;

  var endpoint = String(config.url).trim().replace(/\/+$/, '') + '/api/storefront/carritos';
  var localeRoot = (window.theme && window.theme.localeRootUrl) || '';

  function esc(value) {
    return String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(cents) {
    var amount = (Number(cents) || 0) / 100;
    try { return amount.toLocaleString('es-GT', { style: 'currency', currency: 'GTQ' }); } catch (e) { return 'Q' + amount.toFixed(2); }
  }

  function dateText(iso) {
    try { return new Date(iso).toLocaleDateString('es-GT', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return ''; }
  }

  var MESSAGES = {
    SIGNATURE_EXPIRED: 'Esta página lleva mucho tiempo abierta. Recárgala e inténtalo de nuevo.',
    INVALID_SIGNATURE: 'Recarga la página e inténtalo de nuevo.',
    NOT_CONFIGURED: 'Los carritos guardados no están disponibles en este momento.',
    DATABASE_UNAVAILABLE: 'Los carritos guardados no están disponibles en este momento. Inténtalo en unos minutos.',
    RATE_LIMITED: 'Demasiados intentos seguidos. Espera un minuto e inténtalo de nuevo.'
  };

  // Llama al servicio; rechaza con un Error cuyo message ya es para el cliente.
  function api(action, fields) {
    var body = { customerId: config.customerId, ts: config.ts, sig: config.sig, action: action };
    Object.keys(fields || {}).forEach(function(key) { body[key] = fields[key]; });
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      credentials: 'omit',
      body: JSON.stringify(body)
    }).then(function(response) {
      return response.json().catch(function() { return {}; }).then(function(json) {
        if (response.ok) return json;
        var code = (json && json.error && json.error.code) || ('HTTP_' + response.status);
        var err = new Error(MESSAGES[code] || (json && json.error && json.error.message) || 'No se pudo completar. Inténtalo de nuevo.');
        err.code = code;
        throw err;
      });
    }, function() {
      throw new Error('No pudimos conectarnos. Revisa tu internet e inténtalo de nuevo.');
    });
  }

  function readCart() {
    return fetch(localeRoot + '/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(response) {
        if (!response.ok) throw new Error('No pudimos leer tu carrito. Recarga la página.');
        return response.json();
      });
  }

  function cartPost(path, payload) {
    return fetch(localeRoot + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload || {})
    });
  }

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function refreshCartUi() {
    if (onCartPage()) { window.location.reload(); return; }
    if (window.SideCart && typeof window.SideCart.refresh === 'function') window.SideCart.refresh();
    if (window.CartBadge && typeof window.CartBadge.refresh === 'function') window.CartBadge.refresh();
  }

  /* ----------------------------- interfaz ----------------------------- */

  var toastTimer = null;
  function toast(html) {
    var box = document.getElementById('cvsc-toast');
    if (!box) {
      box = document.createElement('div');
      box.id = 'cvsc-toast';
      box.className = 'cvsc-toast';
      box.setAttribute('role', 'status');
      document.body.appendChild(box);
    }
    box.innerHTML = html;
    box.classList.add('cvsc-toast--show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function() { box.classList.remove('cvsc-toast--show'); }, 6000);
  }

  /*
   * Ventana simple: { title, html, actions: [{ label, kind, onClick(ui) }] }.
   * onClick puede devolver una promesa; mientras corre, los botones se apagan.
   */
  function openModal(options) {
    var overlay = document.createElement('div');
    overlay.className = 'cvsc-overlay';
    overlay.innerHTML =
      '<div class="cvsc-modal" role="dialog" aria-modal="true" aria-labelledby="cvsc-modal-title">' +
        '<button type="button" class="cvsc-modal__close" aria-label="Cerrar">&times;</button>' +
        '<h2 class="cvsc-modal__title" id="cvsc-modal-title">' + esc(options.title) + '</h2>' +
        '<div class="cvsc-modal__body">' + (options.html || '') + '</div>' +
        '<p class="cvsc-modal__error" hidden></p>' +
        '<div class="cvsc-modal__actions"></div>' +
      '</div>';
    var modalNode = overlay.querySelector('.cvsc-modal');
    var errorNode = overlay.querySelector('.cvsc-modal__error');
    var actionsNode = overlay.querySelector('.cvsc-modal__actions');
    var busy = false;

    var ui = {
      root: modalNode,
      close: function() {
        document.removeEventListener('keydown', onKey);
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      },
      error: function(message) {
        errorNode.textContent = message || '';
        errorNode.hidden = !message;
      }
    };

    function setBusy(value) {
      busy = value;
      Array.prototype.forEach.call(actionsNode.querySelectorAll('button'), function(button) { button.disabled = value; });
      modalNode.classList.toggle('cvsc-modal--busy', value);
    }

    function onKey(event) {
      if (event.key === 'Escape' && !busy) ui.close();
      if (event.key === 'Enter' && event.target && event.target.tagName === 'INPUT' && event.target.type === 'text') {
        event.preventDefault();
        var primary = actionsNode.querySelector('.cvsc-btn--primary');
        if (primary && !busy) primary.click();
      }
    }

    (options.actions || []).forEach(function(action) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cvsc-btn cvsc-btn--' + (action.kind || 'ghost');
      button.textContent = action.label;
      button.addEventListener('click', function() {
        if (busy) return;
        if (!action.onClick) { ui.close(); return; }
        ui.error('');
        var result = action.onClick(ui);
        if (result && typeof result.then === 'function') {
          setBusy(true);
          result.then(function() { setBusy(false); }, function(err) {
            setBusy(false);
            ui.error(err && err.message ? err.message : 'No se pudo completar. Inténtalo de nuevo.');
          });
        }
      });
      actionsNode.appendChild(button);
    });

    overlay.addEventListener('click', function(event) { if (event.target === overlay && !busy) ui.close(); });
    overlay.querySelector('.cvsc-modal__close').addEventListener('click', function() { if (!busy) ui.close(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(overlay);
    var focus = modalNode.querySelector('input, .cvsc-btn--primary');
    if (focus) setTimeout(function() { focus.focus(); }, 30);
    return ui;
  }

  /* ----------------------------- guardar ----------------------------- */

  function openLoginPrompt() {
    function go(url) {
      try { localStorage.setItem('login_redirect_url', window.location.href); } catch (e) {}
      window.location.href = url;
    }
    openModal({
      title: 'Guarda tu carrito en tu cuenta',
      html: '<p>Con tu cuenta puedes guardar este carrito con un nombre (por ejemplo, <em>Pedido de baterías Majadas</em>) y cargarlo cuando quieras, desde cualquier dispositivo.</p>',
      actions: [
        { label: 'Cancelar' },
        { label: 'Crear cuenta', kind: 'ghost', onClick: function() { go(config.registerUrl || '/account/register'); } },
        { label: 'Iniciar sesión', kind: 'primary', onClick: function() { go(config.loginUrl || '/account/login'); } }
      ]
    });
  }

  function openSave() {
    if (!config.loggedIn) { openLoginPrompt(); return; }
    readCart().then(function(cart) {
      if (!cart.items || !cart.items.length) {
        toast('Tu carrito está vacío: agrega productos para guardarlo.');
        return;
      }
      var units = cart.item_count || 0;
      openModal({
        title: 'Guardar carrito',
        html:
          '<p class="cvsc-modal__lead">' + cart.items.length + (cart.items.length === 1 ? ' producto' : ' productos') + ' · ' + units + (units === 1 ? ' unidad' : ' unidades') + ' · ' + esc(money(cart.total_price)) + '</p>' +
          '<label class="cvsc-field"><span class="cvsc-field__label">Nombre del carrito</span>' +
          '<input type="text" class="cvsc-field__input" maxlength="80" placeholder="Ej. Pedido de baterías Majadas" autocomplete="off"></label>' +
          '<label class="cvsc-check"><input type="checkbox" class="cvsc-check__input"> <span>Vaciar mi carrito para empezar otro pedido</span></label>',
        actions: [
          { label: 'Cancelar' },
          {
            label: 'Guardar',
            kind: 'primary',
            onClick: function(ui) {
              var input = ui.root.querySelector('.cvsc-field__input');
              var name = input.value.replace(/\s+/g, ' ').trim();
              if (!name) {
                input.focus();
                return Promise.reject(new Error('Ponle un nombre a tu carrito.'));
              }
              var empty = ui.root.querySelector('.cvsc-check__input').checked;
              // Se vuelve a leer: el carrito pudo cambiar con la ventana abierta.
              return readCart().then(function(fresh) {
                if (!fresh.items || !fresh.items.length) throw new Error('Tu carrito está vacío.');
                return api('guardar', { nombre: name, total: fresh.total_price, items: itemsFromCart(fresh) });
              }).then(function(result) {
                ui.close();
                var link = ' <a href="' + esc(config.accountUrl) + '">Ver mis carritos</a>';
                toast('Guardamos <strong>' + esc(result.carrito.nombre) + '</strong>.' + link);
                if (!empty) return;
                return cartPost('/cart/clear.js').then(refreshCartUi, refreshCartUi);
              });
            }
          }
        ]
      });
    }, function(err) {
      toast(esc(err.message));
    });
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest ? event.target.closest('[data-cv-save-cart]') : null;
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openSave();
  }, true);

  /* ----------------------------- cargar ----------------------------- */

  // Agrega las líneas; si alguna está agotada (422), prueba una por una y devuelve las que fallaron.
  function addLines(adds) {
    if (!adds.length) return Promise.resolve([]);
    return cartPost('/cart/add.js', { items: adds }).then(function(response) {
      if (response.ok) return [];
      if (response.status !== 422) throw new Error('No pudimos cargar el carrito. Inténtalo de nuevo.');
      var failed = [];
      return adds.reduce(function(chain, add) {
        return chain.then(function() {
          return cartPost('/cart/add.js', { items: [add] }).then(function(single) {
            if (!single.ok) failed.push(add.id);
          }, function() { failed.push(add.id); });
        });
      }, Promise.resolve()).then(function() { return failed; });
    });
  }

  // Si algo falla después de vaciar, se intenta devolver lo que había.
  function restore(previous) {
    var adds = ((previous && previous.items) || []).map(function(item) {
      return { id: item.variant_id, quantity: item.quantity, properties: item.properties || {} };
    });
    return addLines(adds).catch(function() {});
  }

  function loadSaved(saved, replace) {
    var start = replace
      ? readCart().then(function(previous) {
          return cartPost('/cart/clear.js').then(function() { return previous; });
        })
      : Promise.resolve(null);
    return start.then(function(previous) {
      return addLines(addsFromSaved(saved)).catch(function(err) {
        if (!previous) throw err;
        return restore(previous).then(function() { throw err; });
      });
    }).then(function(failed) {
      if (!failed.length) {
        window.location.href = (localeRoot || '') + '/cart';
        return;
      }
      var names = saved.items.filter(function(line) { return failed.indexOf(line.id) !== -1; }).map(function(line) {
        return '<li>' + esc(line.t) + (line.v ? ' — ' + esc(line.v) : '') + '</li>';
      }).join('');
      var all = failed.length === saved.items.length;
      openModal({
        title: all ? 'No se pudo cargar' : 'Carrito cargado, con faltantes',
        html: '<p>' + (all ? 'Ninguno de estos productos está disponible ahora:' : 'Estos productos no están disponibles ahora y no se agregaron:') + '</p><ul class="cvsc-missing">' + names + '</ul>',
        actions: all
          ? [{ label: 'Entendido', kind: 'primary' }]
          : [{ label: 'Seguir aquí' }, { label: 'Ir al carrito', kind: 'primary', onClick: function() { window.location.href = (localeRoot || '') + '/cart'; } }]
      });
    });
  }

  function openLoad(saved) {
    return readCart().then(function(cart) {
      if (!cart.items || !cart.items.length) return loadSaved(saved, false);
      var count = cart.items.length;
      openModal({
        title: 'Cargar “' + saved.nombre + '”',
        html: '<p>Tu carrito ya tiene ' + count + (count === 1 ? ' producto' : ' productos') + '. ¿Qué quieres hacer?</p>',
        actions: [
          { label: 'Cancelar' },
          { label: 'Agregar a lo que ya tengo', kind: 'ghost', onClick: function(ui) { return loadSaved(saved, false).then(ui.close); } },
          { label: 'Reemplazar mi carrito', kind: 'primary', onClick: function(ui) { return loadSaved(saved, true).then(ui.close); } }
        ]
      });
    });
  }

  /* ------------------------- Mi cuenta → Carritos ------------------------- */

  function imageUrl(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  function cardHtml(saved) {
    var meta = saved.lineas + (saved.lineas === 1 ? ' producto' : ' productos') + ' · ' +
      saved.unidades + (saved.unidades === 1 ? ' unidad' : ' unidades') + ' · Guardado el ' + esc(dateText(saved.creado));
    var items = (saved.items || []).map(function(line) {
      var link = line.h ? (localeRoot || '') + '/products/' + encodeURIComponent(line.h) + '?variant=' + line.id : null;
      var title = esc(line.t) + (line.v ? '<span class="cvsc-item__variant">' + esc(line.v) + '</span>' : '');
      return '<li class="cvsc-item">' +
        (line.img ? '<img class="cvsc-item__img" src="' + esc(imageUrl(line.img)) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="cvsc-item__img cvsc-item__img--none"></span>') +
        '<span class="cvsc-item__text">' + (link ? '<a href="' + esc(link) + '">' + title + '</a>' : title) +
          (line.s ? '<span class="cvsc-item__sku">SKU ' + esc(line.s) + '</span>' : '') + '</span>' +
        '<span class="cvsc-item__qty">× ' + line.q + '</span>' +
      '</li>';
    }).join('');
    return '<article class="cvsc-card" data-id="' + esc(saved.id) + '">' +
      '<div class="cvsc-card__head">' +
        '<div class="cvsc-card__info"><h2 class="cvsc-card__name">' + esc(saved.nombre) + '</h2><p class="cvsc-card__meta">' + meta + '</p></div>' +
        (saved.total !== null && saved.total !== undefined ? '<div class="cvsc-card__total">' + esc(money(saved.total)) + '<small>al guardarlo</small></div>' : '') +
      '</div>' +
      '<ul class="cvsc-items" hidden>' + items + '</ul>' +
      '<div class="cvsc-card__actions">' +
        '<button type="button" class="cvsc-btn cvsc-btn--primary" data-act="cargar">Cargar al carrito</button>' +
        '<button type="button" class="cvsc-btn cvsc-btn--ghost" data-act="ver" aria-expanded="false">Ver productos</button>' +
        '<button type="button" class="cvsc-btn cvsc-btn--ghost" data-act="renombrar">Renombrar</button>' +
        '<button type="button" class="cvsc-btn cvsc-btn--danger" data-act="borrar">Eliminar</button>' +
      '</div>' +
    '</article>';
  }

  function emptyHtml() {
    return '<div class="cvsc-empty">' +
      '<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
      '<p class="cvsc-empty__title">Aún no tienes carritos guardados</p>' +
      '<p class="cvsc-empty__text">Arma tu carrito y toca <strong>Guardar carrito</strong> para ponerle nombre y cargarlo después.</p>' +
      '<a class="cvsc-btn cvsc-btn--primary" href="' + esc((localeRoot || '') + '/search') + '">Buscar productos</a>' +
    '</div>';
  }

  function initPage(listNode) {
    var carts = [];
    var ordered = [];
    try { ordered = JSON.parse((document.getElementById('cv-saved-carts-ordered') || {}).textContent || '[]'); } catch (e) {}

    function render() {
      listNode.innerHTML = carts.length ? carts.map(cardHtml).join('') : emptyHtml();
    }

    function find(id) {
      for (var i = 0; i < carts.length; i++) if (carts[i].id === id) return carts[i];
      return null;
    }

    if (!config.loggedIn) {
      listNode.innerHTML = '<p class="cvsc-error">Inicia sesión para ver tus carritos.</p>';
      return;
    }

    api('listar', { pedidos: ordered }).then(function(result) {
      carts = result.carritos || [];
      render();
    }, function(err) {
      listNode.innerHTML = '<p class="cvsc-error">' + esc(err.message) + '</p>';
    });

    listNode.addEventListener('click', function(event) {
      var button = event.target.closest ? event.target.closest('[data-act]') : null;
      if (!button) return;
      var card = button.closest('.cvsc-card');
      var saved = card && find(card.getAttribute('data-id'));
      if (!saved) return;
      var act = button.getAttribute('data-act');

      if (act === 'ver') {
        var list = card.querySelector('.cvsc-items');
        list.hidden = !list.hidden;
        button.textContent = list.hidden ? 'Ver productos' : 'Ocultar productos';
        button.setAttribute('aria-expanded', String(!list.hidden));
        return;
      }

      if (act === 'cargar') {
        button.disabled = true;
        openLoad(saved).then(function() { button.disabled = false; }, function(err) {
          button.disabled = false;
          toast(esc(err && err.message ? err.message : 'No pudimos cargar el carrito.'));
        });
        return;
      }

      if (act === 'renombrar') {
        var modal = openModal({
          title: 'Renombrar carrito',
          html: '<label class="cvsc-field"><span class="cvsc-field__label">Nombre del carrito</span><input type="text" class="cvsc-field__input" maxlength="80" autocomplete="off"></label>',
          actions: [
            { label: 'Cancelar' },
            {
              label: 'Guardar',
              kind: 'primary',
              onClick: function(ui) {
                var name = ui.root.querySelector('.cvsc-field__input').value.replace(/\s+/g, ' ').trim();
                if (!name) return Promise.reject(new Error('Ponle un nombre a tu carrito.'));
                return api('renombrar', { id: saved.id, nombre: name }).then(function(result) {
                  saved.nombre = result.carrito.nombre;
                  ui.close();
                  render();
                });
              }
            }
          ]
        });
        modal.root.querySelector('.cvsc-field__input').value = saved.nombre;
        return;
      }

      if (act === 'borrar') {
        openModal({
          title: '¿Eliminar “' + saved.nombre + '”?',
          html: '<p>El carrito guardado se borra de tu cuenta. Tu carrito actual no cambia.</p>',
          actions: [
            { label: 'Cancelar' },
            {
              label: 'Eliminar',
              kind: 'danger',
              onClick: function(ui) {
                return api('borrar', { id: saved.id }).then(function() {
                  carts = carts.filter(function(other) { return other.id !== saved.id; });
                  ui.close();
                  render();
                  toast('Eliminamos <strong>' + esc(saved.nombre) + '</strong>.');
                });
              }
            }
          ]
        });
      }
    });
  }

  window.CVSavedCarts.api = api;
  window.CVSavedCarts.load = loadSaved;

  var listNode = document.querySelector ? document.querySelector('[data-cvsc-list]') : null;
  if (listNode) initPage(listNode);
})();
